export default __webpack_public_path__ + "static/media/financial-2.kontrast.a5ec3d31.svg";